export default __webpack_public_path__ + "static/media/image-homepage-profile@2x.bd63a80a.jpg";